import React from "react";
import formatMoney from "@admin/domain/orders/formatMoney";
import { useLoaderContext } from "@admin/components/LoaderContext";
import { useOrderHooks } from "@admin/pages/OrderEditor/hooks";
import { registerInAccounting, registerPaymentInAccounting, unblockAccountingExport } from "@admin/domain/orders/api";
import { useOrderContext } from "@admin/pages/OrderEditor/OrderContext";
import RegisterCustomPaymentInAccountingModal from "./RegisterCustomPaymentInAccountingModal";

export default function Accounting() {
    const { order } = useOrderContext();
    const { isLoading } = useLoaderContext();
    const { orderRequest } = useOrderHooks();
    const [modalIsOpened, setModalIsOpened] = React.useState<boolean>(false);

    const register = (): void => {
        orderRequest(async (): Promise<null> => await registerInAccounting(order.id));
    };

    const registerPayment = (): void => {
        orderRequest(async (): Promise<null> => await registerPaymentInAccounting(order.id));
    };

    const unblock = (): void => {
        orderRequest(async (): Promise<null> => await unblockAccountingExport(order.id));
    };

    return (
        <>
            <h4 className="mb-7">Синхронизация с 1С</h4>

            {order.has_payment_amount_mismatch && (
                <div className="alert alert-danger">
                    <p>Сумма платежа не совпадает с суммой заказа. Выгрузка в 1С и печать чека заблокированы.</p>
                    <p>После проверки и исправления ошибки снимите блокировку, затем выполните нужную операцию вручную.</p>
                    <a className="d-block mb-3" href={`/admin/orders/attention-events?order_id=${order.id}&status=all`}>
                        Посмотреть событие
                    </a>
                    <button type="button" className="btn btn-warning" onClick={unblock} disabled={isLoading}>
                        Снять блокировку выгрузки
                    </button>
                </div>
            )}

            <div className="mb-5">
                <span className="fw-bolder">GUID заказа: </span>{` `}{order.id_from_1c}
            </div>

            <div className="mb-5">
                <span className="fw-bolder">GUID платежа по заказу: </span>{` `}{order.payment_external_id}
            </div>

            <div className="mb-5">
                <span
                    className="fw-bolder">ID платежа: </span>{` `}
                {order.logs.find((log) => log.action === `order_payment_was_registered`)?.context?.[`1c_data`]
                    ?.pay_id}
            </div>

            <div className="mb-5">
                <span
                    className="fw-bolder">Сумма платежа: </span>{` `}
                {order.is_parent || !order.id_from_1c ? `` : formatMoney(order, `total_amount`)}
            </div>

            <div className="mb-5">
                <span
                    className="fw-bolder">Дата платежа: </span>{` `}
                {order.paid_at}
            </div>

            <button type="button" className="btn btn-info mb-5 me-2" onClick={register} disabled={isLoading || order.has_payment_amount_mismatch}>
                Отправить заказ
            </button>

            <button type="button" className="btn btn-info mb-5 me-2" onClick={registerPayment} disabled={isLoading || order.has_payment_amount_mismatch}>
                Отправить платеж
            </button>

            {!order.payment_external_id && (
                <button
                    type="button"
                    className="btn btn-info mb-5 me-2"
                    onClick={(): void => setModalIsOpened(true)}
                    disabled={isLoading}
                >
                    Ручное формирование платежа
                </button>
            )}

            {modalIsOpened && (
                <RegisterCustomPaymentInAccountingModal
                    orderId={order.id}
                    closeModal={(): void => setModalIsOpened(false)}
                />
            )}
        </>
    );
}
